// Single stage list for every status UI — runner stages from GET /pipeline/stages (stored value + designer label).
import { useEffect, useState } from 'react';

export const FALLBACK_STAGES = [
  ['client_data', 'Client Data', 'Client Data'], ['appraisal_booked', 'Appraisal Booked', 'Appraisal Booked'],
  ['quote_sent', 'Quote Sent', 'Quoting'], ['accepted', 'Accepted', 'Accepted'], ['declined', 'Declined', 'Declined'],
  ['work_booked', 'Work Booked', 'Work Booked'], ['work_in_progress', 'Work In Progress', 'Work In Progress'],
  ['completed', 'Completed', 'Completed'], ['invoiced', 'Invoiced', 'Invoiced'], ['overdue', 'Overdue', 'Overdue'],
  ['paid', 'Paid', 'Paid'], ['closed_lost', 'Closed · Lost', 'Closed · Lost'], ['closed_bad_debt', 'Closed · Bad Debt', 'Closed · Bad Debt'],
  ['tribunal_path', 'Tribunal Path', 'Tribunal Path'],
].map(([key, value, label], order) => ({ key, value, label, order }));

let cache = null;
let inflight = null;

export function useStages(api) {
  const [stages, setStages] = useState(cache || FALLBACK_STAGES);
  useEffect(() => {
    if (cache || !api) return undefined;
    let alive = true;
    inflight = inflight || api.get('/pipeline/stages').then(({ data }) => { cache = data?.stages?.length ? data.stages : FALLBACK_STAGES; return cache; })
      .catch(() => FALLBACK_STAGES).finally(() => { inflight = null; });
    inflight.then((s) => { if (alive) setStages(s); });
    return () => { alive = false; };
  }, [api]);
  return stages;
}

export const stageLabel = (stages, value) => (stages.find((s) => s.value === value)?.label) || value || '—';
